import { useEffect, useState } from "react";

function useLocalStorage(key, initialValue) {
    const isClient = typeof window !== "undefined";

    const [storedValue, setStoredValue] = useState(() => {
        if (!isClient) return initialValue;

        try {
            const item = window.localStorage.getItem(key);
            return item ? JSON.parse(item) : initialValue;
        } catch (error) {
            console.warn("Error reading localStorage key:", key, error);
            return initialValue;
        }
    });

    useEffect(() => {
        if (!isClient) return;

        try {
            window.localStorage.setItem(key, JSON.stringify(storedValue));
        } catch (error) {
            console.warn("Error writing localStorage key:", key, error);
        }
    }, [key, storedValue]);

    return [storedValue, setStoredValue];
}

export default useLocalStorage;
